import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import API from "../../api";
import EventEntryForm from "./_components/EventEntryForm";
import Box from "../../components/common/Box";

function CloneEvent(){
  const { event_id } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({});

  useEffect(() => {
    getData();
  }, []);

  const getData = useCallback(() => {
    API.calendar.getEvent(event_id).then((res) => {
      setData(res);

      setIsLoading(false);
    });
  }, [event_id]);

  const handleSubmit = data => {
    API.calendar.createEvent(data).then((res) => {
      toast.success("Successfully cloned event");
      navigate(`/events/event/${res._id}`);
    });
  };

  if(isLoading){
    return (
      <div className={"p-2"}>
        Loading...
      </div>
    );
  }

  return (
    <div className={"p-4"}>
      <Box title={"Clone Event"}>
        <div className={"p-2"}>
          <EventEntryForm isClone={true} onSubmit={handleSubmit} data={data} onCancel={() => navigate(`/events/event/${event_id}`)} />
        </div>
      </Box>
    </div>
  );
}
export default CloneEvent;